(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/common'], factory) :
	(factory((global['ngx-isotope'] = {}),global._angular_core,global._angular_common));
}(this, (function (exports,_angular_core,_angular_common) { 'use strict';

var IsotopeGridComponent = (function () {
    /**
     * @param {?} el
     */
    function IsotopeGridComponent(el) {
        this.el = el;
        this.items = [];
    }
    /**
     * @return {?}
     */
    IsotopeGridComponent.prototype.ngOnInit = function () {
        if (!this.options)
            this.options = {};
        if (!this.options.itemSelector) {
            this.options.itemSelector = '[isotope-item], isotope-item';
        }
        if (this.el.nativeElement.tagName === 'ISOTOPE-GRID') {
            this.el.nativeElement.style.display = 'block';
        }
        this.isotope = new Isotope(this.el.nativeElement, this.options);
    };
    /**
     * @param {?} el
     * @return {?}
     */
    IsotopeGridComponent.prototype.add = function (el) {
        var _this = this;
        this.isotope.appended(el);
        this.isotope.layout();
        imagesLoaded(el).on('progress', function () {
            _this.isotope.layout();
        });
    };
    return IsotopeGridComponent;
}());
IsotopeGridComponent.decorators = [
    { type: _angular_core.Component, args: [{
                selector: 'isotope-grid',
                template: "<ng-content></ng-content> ",
                styles: [""]
            },] },
];
/**
 * @nocollapse
 */
IsotopeGridComponent.ctorParameters = function () { return [
    { type: _angular_core.ElementRef, },
]; };
IsotopeGridComponent.propDecorators = {
    'options': [{ type: _angular_core.Input },],
};

var IsotopeItemComponent = (function () {
    /**
     * @param {?} grid
     * @param {?} el
     */
    function IsotopeItemComponent(grid, el) {
        this.grid = grid;
        this.el = el;
    }
    /**
     * @return {?}
     */
    IsotopeItemComponent.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    IsotopeItemComponent.prototype.ngAfterViewInit = function () {
        this.grid.add(this.el.nativeElement);
    };
    return IsotopeItemComponent;
}());
IsotopeItemComponent.decorators = [
    { type: _angular_core.Component, args: [{
                selector: 'isotope-item',
                template: "<ng-content></ng-content> ",
                styles: [""]
            },] },
];
/**
 * @nocollapse
 */
IsotopeItemComponent.ctorParameters = function () { return [
    { type: IsotopeGridComponent, },
    { type: _angular_core.ElementRef, },
]; };

var IsotopeModule = (function () {
    function IsotopeModule() {
    }
    /**
     * @return {?}
     */
    IsotopeModule.forRoot = function () {
        return {
            ngModule: IsotopeModule,
            providers: []
        };
    };
    return IsotopeModule;
}());
IsotopeModule.decorators = [
    { type: _angular_core.NgModule, args: [{
                imports: [
                    _angular_common.CommonModule
                ],
                declarations: [
                    IsotopeGridComponent,
                    IsotopeItemComponent,
                ],
                exports: [
                    IsotopeGridComponent,
                    IsotopeItemComponent,
                ]
            },] },
];
/**
 * @nocollapse
 */
IsotopeModule.ctorParameters = function () { return []; };

exports.IsotopeModule = IsotopeModule;
exports.IsotopeGridComponent = IsotopeGridComponent;
exports.IsotopeItemComponent = IsotopeItemComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));
